<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.view_notification_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #266db0">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <!-- Start:: Title Ar Input -->
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.send_date')"
                v-model.trim="data.date"
                disabled
              />
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleAr')"
                v-model.trim="data.titleAr"
                disabled
              />
              <!-- End:: Title Ar Input -->

              <!-- Start:: Title En Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleEn')"
                v-model.trim="data.titleEn"
                disabled
              />
              <!-- End:: Title En Input -->

              <!-- Start:: Content Ar Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentAr')"
                v-model.trim="data.contentAr"
                disabled
              />
              <!-- End:: Content Ar Input -->

              <!-- Start:: Content En Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentEn')"
                v-model.trim="data.contentEn"
                disabled
              />
              <!-- End:: Content En Input -->

              <!-- Start:: Receiver Type Input -->
              <base-select-input
                col="6"
                :optionsList="receiverTypes"
                :placeholder="$t('PLACEHOLDERS.receiverType')"
                v-model="data.receiverType"
                disabled
              />
              <!-- End:: Receiver Type Input -->

              <!-- Start:: Clients Type Input -->
              <base-select-input
                v-if="data.clients && data.receiverType.value === 'client'"
                col="12"
                :optionsList="data.clients"
                :placeholder="$t('PLACEHOLDERS.recievers')"
                v-model="data.client"
                disabled
                multiple
              />
              <!-- End:: Clients Type Input -->

              <!-- Start:: service_providers Type Input -->
              <base-select-input
                v-if="data.providers && data.receiverType.value === 'provider'"
                col="6"
                :optionsList="data.providers"
                :placeholder="$t('PLACEHOLDERS.service_providers_plural')"
                v-model="data.provider"
                disabled
                multiple
              />
              <!-- End:: Drivers Type Input -->
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNotification",

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allClientsData: "ApiGetsModule/allClientsData",
      allDriversData: "ApiGetsModule/allDriversData",
    }),
    // End:: Vuex Getters

    receiverTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.service_seeker_singular"),
          value: "client",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.all_service_seekers"),
          value: "clients",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.service_provider_singular"),
          value: "provider",
        },
        {
          id: 4,
          name: this.$t("PLACEHOLDERS.all_service_providers"),
          value: "providers",
        },
        {
          id: 5,
          name: this.$t("PLACEHOLDERS.service_driver_singular"),
          value: "driver",
        },
        {
          id: 7,
          name: this.$t("PLACEHOLDERS.delivery"),
          value: "delivery",
        },
        {
          id: 5,
          name: this.$t("PLACEHOLDERS.all"),
          value: "all",
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        receiverType: {
          id: 1,
          name: this.$t("PLACEHOLDERS.service_seeker_singular"),
          value: "client",
        },
        clients: [],
        providers: [],
        client: [],
        provider: [],
        titleAr: null,
        titleEn: null,
        contentAr: null,
        contentEn: null,
        date: null,
      },

      // End:: Data Collection To Send
    };
  },
  watch: {
    "data.clients"() {
      this.data.clients.forEach((value) => {
        if (value.id == "-1") {
          this.data.clients = this.allClientsData;
          return;
        }
      });
    },
    "data.drivers"() {
      this.data.drivers.forEach((value) => {
        if (value.id == "-1") {
          this.data.drivers = this.allDriversData;
          return;
        }
      });
    },
  },

  methods: {
    // End:: Vuex Actions

    async getClients() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `clients?page=0`,
        });

        this.data.clients = res.data.data.data;
        console.log(" this.data.clients", this.data.clients);
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getProviders() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers?page=0`,
        });
        console.log("this.data.providers", res);

        this.data.providers = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getNotificationData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `notification/show?notification_id=${this.$route.params.id}`,
        });
        console.log("res", res);
        let data = res.data.data.notification;
        this.data.titleAr = data?.title_ar;
        this.data.titleEn = data?.title_en;
        this.data.contentAr = data?.body_ar;
        this.data.contentEn = data?.body_en;
        this.data.date = data?.created_at;
        this.data.client = data?.notifiable;
        this.data.provider = data?.notifiable;
        this.data.receiverType = data.notifiable.type;
        console.log("this.data.receiverType", this.data.receiverType);

        if (this.data.receiverType == "client") {
          this.data.receiverType = {
            id: 1,
            name: this.$t("PLACEHOLDERS.service_seeker_singular"),
            value: "client",
          };
        } else if (this.data.receiverType == "clients") {
          this.data.receiverType = {
            id: 2,
            name: this.$t("PLACEHOLDERS.all_service_seekers"),
            value: "clients",
          };
        } else if (this.data.receiverType == "provider") {
          this.data.receiverType = {
            id: 3,
            name: this.$t("PLACEHOLDERS.service_provider_singular"),
            value: "provider",
          };
        } else if (this.data.receiverType == "providers") {
          this.data.receiverType = {
            id: 1,
            name: this.$t("PLACEHOLDERS.all_service_providers"),
            value: "providers",
          };
        } else if (this.data.receiverType == "driver") {
          this.data.receiverType = {
            id: 3,
            name: this.$t("PLACEHOLDERS.service_driver_singular"),
            value: "provider",
          };
        } else if (this.data.receiverType == "drivers") {
          this.data.receiverType = {
            id: 1,
            name: this.$t("PLACEHOLDERS.all_service_drivers"),
            value: "providers",
          };
        } else if (this.data.receiverType == "delivery") {
          this.data.receiverType = {
            id: 1,
            name: this.$t("PLACEHOLDERS.all_service_providers"),
            value: "providers",
          };
        } else if (this.data.receiverType == "all") {
          this.data.receiverType = {
            id: 5,
            name: this.$t("PLACEHOLDERS.all"),
            value: "all",
          };
        }
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    this.getNotificationData();
    this.getClients();
    this.getProviders();
    // End:: Fire Methods
  },
};
</script>
